<template>
  <div id="rewards">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <h1>Claim A Reward</h1>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card color="blue" dark>
            <v-card-text>
              <v-row align="center">
                <v-col cols="5">
                  <v-card-title class="headline text-start">Balance</v-card-title>
                  <v-card-subtitle class="text-start">Your current balance</v-card-subtitle>
                </v-col>
                <v-col class="display-2 text-end" cols="7">${{ (balance/100).toFixed(2) }}</v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card dark>
            <v-card-text>
              <v-row align="center">
                <v-col cols="6">
                  <v-card-title class="headline text-start">
                    Claim
                    <br />Reward
                  </v-card-title>
                  <v-card-subtitle
                    class="text-start"
                  >Please select the gift card amount, up to a maximum of $50 per day (this must be in multiples of $5)</v-card-subtitle>
                </v-col>
                <v-col class="display-2 text-center" cols="6">
                  <div
                    v-if="error"
                    class="subtitle-1 red--text text--accent-3"
                  >Please select an amount</div>
                  <v-overflow-btn
                    class
                    :items="spendAmounts"
                    label="Amount"
                    v-model="claimAmount"
                    @change="amountChanged"
                  ></v-overflow-btn>
                  <div
                    v-if="regionError"
                    class="subtitle-1 red--text text--accent-3"
                  >Please select a Gift Card region</div>
                  <v-overflow-btn class :items="regions" label="GiftPay Region" v-model="region"></v-overflow-btn>
                  <v-btn color="primary text-center" @click.prevent="claimReward">Claim reward</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <h1>Your Rewards</h1>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Date</th>
                <th class="text-left">Amount</th>
                <th class="text-left">Expiry</th>
                <th class="text-left">Region</th>
                <th class="text-left">
                  Giftpay
                  <br />Reference
                </th>
                <th class="text-left">Reward Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="reward in rewards" :key="reward.gift_id">
                <td>
                  <h4>{{ reward.date | moment('timezone', timezone, " h:mma") }}</h4>
                  {{ reward.date | moment('timezone', timezone, " Do MMMM YYYY") }}
                </td>
                <td>${{ (reward.amount/100).toFixed(2) }}</td>
                <td>{{ reward.expiry | moment('timezone', timezone, " Do MMMM YYYY") }}</td>
                <td>{{ reward.region }}</td>
                <td>{{ reward.gift_id }}</td>
                <td>{{ reward.status.Message }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-row>
    </v-container>
    <v-dialog v-model="modal" max-width="290">
      <v-card>
        <v-card-title class="headline">Your Purchase</v-card-title>
        <v-card-text>{{ purchaseMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="modal = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);

axios.defaults.baseURL = process.env.VUE_APP_BASEAPI;

export default {
  name: "Rewards",
  data() {
    return {
      error: false,
      regionError: false,
      modal: false,
      balance: 0,
      rewards: [],
      amountToSpend: 0,
      spendAmounts: [],
      claimAmount: 0,
      purchaseMessage: "",
      rates: {},
      regions: [],
      region: ""
    };
  },
  mounted() {
    this.getRegions();
    this.getBalance();
    this.getRewards();
    this.getTimezone();
  },
  computed: {},
  methods: {
    getRegions() {
      this.$store.dispatch("retrieveRates").then(() => {
        this.rates = this.$store.getters.rates;
        this.regions = [];
        for (const rate in this.rates) {
          // if(rate == "sandbox") {
          //   continue;
          // }
          var region = "";
          var conversion = 0;
          switch (rate) {
            case "au":
              region = "Australia";
              conversion = this.rates[rate];
              break;
            case "us":
              region = "United States";
              conversion = this.rates[rate];
              break;
            case "uk":
              region = "United Kingdom";
              conversion = this.rates[rate];
              break;
            case "nz":
              region = "New Zealand";
              conversion = this.rates[rate];
              break;
            default:
              region = "Sandbox";
              conversion = this.rates[rate];
              break;
          }
          if (this.claimAmount !== 0) {
            var convertedAmount = this.claimAmount/conversion;
            this.regions.push({
              text: region + " ($" + convertedAmount.toFixed(2) + ")",
              value: rate
            });
          } else {
            this.regions.push({
              text:
                region +
                " ($1.00 buys $" +
                this.rates[rate].toFixed(2) +
                ")",
              value: rate
            });
          }
        }
      });
    },
    getRewards() {
      this.$store.dispatch("retrieveRewards").then(() => {
        this.rewards = this.$store.getters.rewards;
      });
    },
    getTimezone() {
      this.timezone = this.$moment.tz.guess();
    },
    getBalance() {
      this.$store.dispatch("retrieveBalance").then(() => {
        this.balance = this.$store.getters.balance;
        if (this.balance > 0) {
          this.amountToSpend = Math.floor(this.balance / 100 / 5.0) * 5;
          if (this.amountToSpend > 50) {
            this.amountToSpend = 50;
          }
          for (var i = 5; i <= this.amountToSpend; i++) {
            if (i % 5 === 0) {
              this.spendAmounts.push({
                text: "$" + i,
                value: i
              });
            }
          }
        }
      });
    },
    claimReward() {
      if (this.claimAmount === 0) {
        this.error = true;
        return;
      } else {
        this.error = false;
      }
      if (this.region == "") {
        this.regionError = true;
        return;
      } else {
        this.regionError = false;
      }
      var amount = this.claimAmount * 100;
      // console.log(amount);
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");
      Vue.axios
        .post("rewards/purchase", {
          amount: amount,
          from: "Damnn Bank",
          region: this.region
        })
        .then(() => {
          this.purchaseMessage =
            "Congratulations, a Gift Card for $" +
            amount / 100 +
            " has been sent to you via email. Please check your email and follow the instructions.";
          this.getBalance();
          this.getRewards();
          this.error = false;
          this.modal = true;
        })
        .catch(() => {
          this.purchaseMessage =
            "Sorry, we're unable to process your Gift Card at this time, please try again later.";
          this.getBalance();
          this.getRewards();
          this.error = false;
          this.modal = true;
        });
    },
    amountChanged() {
      if (this.claimAmount === 0) {
        this.error = true;
        return;
      } else {
        this.error = false;
      }
      this.getRegions();
    }
  }
};
</script>

<style scoped>
</style>